import React from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const MinistryNeedy = () => {
  return (
    <>
      <SEOHead path="/ministry-for-needy" />
      <PageHeader title="Ministry for the Needy" breadcrumb="Ministry for the Needy" />

      <section className="section">
        <div className="container">
          <div className="content-page fade-in">
            <div className="content-body">
              <p>Under the umbrella of Teen Challenge Armenia operates the Ministry for the Needy, guided by David Manukyan. This ministry is dedicated to extending its reach to the overlooked and underserved, including impoverished families, those dwelling in remote areas of Armenia, and households with more than three children.</p>

              <p>Our mission goes beyond providing basic necessities such as food, clothing, and housing repairs. We aim to instill hope through sharing the Gospel, uplifting those in need not just materially, but spiritually. Furthermore, we offer psychological support acknowledging the crucial role of mental well-being in overcoming adversity.</p>

              <p>In our pursuit of "reaching those whom no one reaches", we strive to illuminate paths, inspire resilience, and foster a sense of belonging among the marginalized.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MinistryNeedy;
